import { OnboardingProductType } from "domain/onboardings";
import { apiGatewayService, ApiType } from "services/api/ApiGatewayService";
import { ParameterQuery } from "utils/commonFunctions";

const PATH_ONBOARDINGS_API = "/api/v1/onboardings";

export interface OnboardingDto {
    user_uuid?: string;
    product: string;
    workflow_template_uuid?: string;
    step: string;
    feedback_submitted: boolean;
}

export interface Onboarding {
    userUuid?: string;
    product: string;
    workflowTemplateUuid?: string;
    step: string;
    feedbackSubmitted?: boolean;
}

function toOnboardingDto(dto: OnboardingDto): Onboarding {
    return {
        userUuid: dto.user_uuid,
        product: dto.product,
        workflowTemplateUuid: dto.workflow_template_uuid,
        step: dto.step,
        feedbackSubmitted: dto.feedback_submitted,
    };
}

export class OnboardingsService {
    public async fetchOnboardings(product?: string, abortController?: AbortController) {
        return apiGatewayService
            .invokeApi(
                PATH_ONBOARDINGS_API + new ParameterQuery().add("product", product).createQueryString(),
                "GET",
                null,
                {
                    abortSignal: abortController?.signal,
                    apiType: ApiType.ARTHUR,
                    includeCredentials: true,
                }
            )
            .then((onboardingsList: OnboardingDto[]) => {
                return onboardingsList.map(toOnboardingDto);
            });
    }

    public async fetchOnboardedProducts(abortController?: AbortController) {
        return apiGatewayService
            .invokeApi(PATH_ONBOARDINGS_API, "GET", null, {
                abortSignal: abortController?.signal,
                apiType: ApiType.ARTHUR,
                includeCredentials: true,
            })
            .then((onboardingsList: OnboardingDto[]) => {
                return onboardingsList;
            });
    }

    public saveOnboardingStep(steps: Onboarding, abortController?: AbortController): Promise<void> {
        const dto: OnboardingDto = {
            product: steps.product,
            step: steps.step,
            workflow_template_uuid: steps.workflowTemplateUuid,
            feedback_submitted: steps.feedbackSubmitted || false,
        };
        return apiGatewayService.invokeApi(PATH_ONBOARDINGS_API, "POST", dto, {
            abortSignal: abortController?.signal,
            apiType: ApiType.ARTHUR,
            includeCredentials: true,
        });
    }

    public submitFeedback(
        product: OnboardingProductType,
        step: string,
        abortController: AbortController
    ): Promise<void> {
        const dto: OnboardingDto = {
            product: product.valueOf(),
            feedback_submitted: true,
            step: step,
        };
        return apiGatewayService.invokeApi(PATH_ONBOARDINGS_API, "POST", dto, {
            abortSignal: abortController?.signal,
            apiType: ApiType.ARTHUR,
            includeCredentials: true,
        });
    }
}

export const onboardingsService = new OnboardingsService();
